import SearchBar from './SearchBar';

export default SearchBar;


// WEBPACK FOOTER //
// ./src/components/SearchBar/index.js